/**
 * GetKioskCsmsNamesUseCase
 *
 * Fetches the list of available CSMS names for external CPO Kiosk connection setup.
 * GET /ocpi-admin/csms
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';

export class GetKioskCsmsNamesUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  async execute(): Promise<string[]> {
    return this.repository.getKioskCsmsNames();
  }
}
